import { useRouter } from 'next/router'
import { useState } from 'react'
import { MapSearchSortInput as Input } from 'ui-components'
import { getSearchQuery } from 'utils'

export function MapSearchSortInput() {
  const router = useRouter()
  const [value, setValue] = useState(Input.defaultValue)

  const handleChange = (event, value) => {
    setValue(value)
    router.push(getSearchQuery({ sort: value }), undefined, { shallow: true })
  }

  return (
    <Input
      value={value}
      onChange={handleChange}
    />
  )
}
